export const CABANAS = [
    {
        id: "cabana01",
        nome: "Cabana da Barra 01",
        slug: "cabana-da-barra-01",
        diaria: 1050,
        capa: "/cabanas/cabana01/capa.webp",
        fotos: [
            "/cabanas/cabana01/capa.webp",
            "/cabanas/cabana01/foto_01.avif",
            "/cabanas/cabana01/foto_02.avif",
            "/cabanas/cabana01/foto_03.avif",
            "/cabanas/cabana01/foto_04.avif",
            "/cabanas/cabana01/foto_05.avif",
            "/cabanas/cabana01/foto_06.avif",
            "/cabanas/cabana01/foto_07.avif",
            "/cabanas/cabana01/foto_08.avif",
            "/cabanas/cabana01/foto_09.avif",
        ],
        destaque: "Mirante com pergolado e 2 decks",
        comodidades: [
            "Piscina privativa aquecida 24hrs",
            "Cama massageadora",
            "Cabana automatizada com controle de voz e integrada a Alexa",
            "Ar condicionado split",
            "Smart TV 4K de 55' com Netflix e canais abertos e fechados",
            "Cozinha completa",
            "Chuveirão de eucalipto",
            "Vista deslumbrante da Mata Atlântica",
            "Mirante com pergolado e sofá",
            "Banheiro de vidro",
            "2 decks",
            "Kit de decoração romântica opcional",
        ],
    },
    {
        id: "cabana02",
        nome: "Cabana da Barra 02",
        slug: "cabana-da-barra-02",
        diaria: 1050,
        capa: "/cabanas/cabana02/foto_01.avif",
        fotos: [
            "/cabanas/cabana02/foto_01.avif",
            "/cabanas/cabana02/foto_02.avif",
            "/cabanas/cabana02/foto_03.avif",
            "/cabanas/cabana02/foto_04.avif",
            "/cabanas/cabana02/foto_05.avif",
            "/cabanas/cabana02/foto_06.avif",
            "/cabanas/cabana02/foto_07.avif",
            "/cabanas/cabana02/foto_08.avif",
            "/cabanas/cabana02/foto_09.avif",
            "/cabanas/cabana02/foto_10.avif",
        ],
        destaque: "Balanço de eucalipto e deck suspenso",
        comodidades: [
            "Piscina privativa aquecida 24hrs",
            "Cama massageadora",
            "Cabana automatizada com controle de voz e integrada a Alexa",
            "Ar condicionado split",
            "Smart TV 4K de 55' com Netflix e canais abertos e fechados",
            "Cozinha completa",
            "Balanço de eucalipto",
            "Deck suspenso com pergolado",
            "Vista deslumbrante da Mata Atlântica",
            "Banheiro de vidro",
            "Kit de decoração romântica opcional",
        ],
    },
    {
        id: "aquario",
        nome: "Cabana Aquário",
        slug: "cabana-aquario",
        diaria: 930,
        capa: "/cabanas/aquario/capa.webp",
        fotos: [
            "/cabanas/aquario/capa.webp",
            "/cabanas/aquario/foto_01.avif",
            "/cabanas/aquario/foto_02.avif",
            "/cabanas/aquario/foto_03.avif",
            "/cabanas/aquario/foto_04.avif",
            "/cabanas/aquario/foto_05.avif",
            "/cabanas/aquario/foto_06.avif",
            "/cabanas/aquario/foto_07.avif",
            "/cabanas/aquario/foto_08.avif",
            "/cabanas/aquario/foto_09.avif",
        ],
        destaque: "Tela de cinema 70' retrátil e churrasqueira",
        comodidades: [
            "Banheira de imersão aquecida 24hrs",
            "Cama massageadora",
            "Cabana automatizada com comandos de voz e integrada a Alexa",
            "Ar condicionado split",
            "Tela de Cinema 70' retrátil por comando de voz",
            "Netflix e canais abertos e fechados",
            "Cozinha completa",
            "Chuveirão",
            "Deck suspenso com mesa e churrasqueira a gás",
            "Vista deslumbrante da Mata Atlântica",
            "Banheiro de vidro",
            "Kit de decoração romântica opcional",
        ],
    },
];

export const DECORACOES = [
    {
        id: "nenhuma",
        nome: "Sem decoração",
        preco: 0,
        descricao: "Sem kit de decoração romântica.",
    },
    {
        id: "basica",
        nome: "Básica",
        preco: 350,
        descricao: "Pétalas de rosas, velas aromáticas, balões em coração, frutas e chocolates finos.",
        imagem: "https://images.pexels.com/photos/36845212/pexels-photo-36845212.jpeg",
        ideal: "Ideal para surpresas simples e delicadas",
    },
    {
        id: "premium",
        nome: "Premium",
        preco: 480,
        descricao:
            "Cama decorada com pétalas em coração, balões no teto, velas + luminárias LED, bandeja com espumante e morangos, música ambiente personalizada.",
        imagem: "https://images.pexels.com/photos/9985641/pexels-photo-9985641.jpeg",
        ideal: "Perfeito para aniversários de namoro ou pedidos especiais",
    },
    {
        id: "luxo",
        nome: "Luxo",
        preco: 650,
        descricao:
            "Caminho de pétalas, cama com iniciais do casal, balões metalizados + cortina de coração, iluminação romântica, espumante + taças + frutas + fondue de chocolate, toalhas dobradas em cisnes apaixonados.",
        imagem: "https://images.pexels.com/photos/20944030/pexels-photo-20944030.jpeg",
        ideal: "Ideal para noites de núpcias ou datas marcantes",
    },
];

export const FAQ_ITEMS = [
    {
        q: "Posso levar meu pet?",
        a: "Sim! Somos pet friendly. Cobramos uma taxa de R$ 200,00 para higienização do espaço após a hospedagem com animais de estimação.",
    },
    {
        q: "Algo incluso na acomodação?",
        a: "Sim! Café da manhã e jantar é incluso na acomodação.",
    },
    {
        q: "Onde fica localizado?",
        a: "A Cabana da Barra fica no bairro Barra de Guaratiba, na Zona Oeste do Rio de Janeiro.",
    },
    {
        q: "Qual o horário de Check-in?",
        a: "Check-in a partir das 15:00 horas.",
    },
    {
        q: "Qual o horário de Check-out?",
        a: "Check-out até as 12:00 horas.",
    },
];

export const CONTATO = {
    nome: "Cabanas da Barra",
    endereco: "Estr. Roberto Burle Marx, 2069 - Barra de Guaratiba, Rio de Janeiro - RJ, 23020-255, Brasil",
    telefone: "21 96759-8470",
    whatsapp: "5521967598470",
    email: "admcabanasdabarra@gmail.com",
    cnpj: "30.093.561/0001-43",
};
